import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const TestPaperService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 试卷分页
     */
    testPaperPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'testPaper/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得试卷
    */
    testPaperGetById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'testPaper/getById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得试卷详情
    */
    testPaperGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'testPaper/getDetailsById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 试卷克隆
     */
    testPaperClone({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'testPaper/clone/' + params.id, params.paperName).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 试卷保存
     */
    testPaperSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'testPaper/save', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 试卷更新
     */
    testPaperUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'testPaper/update/' + params.id, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 试卷删除
     */
    testPaperRemove({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'testPaper/remove', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    testPaperChangeIsState({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + `testPaper/changeIsState/${params.id}`, params.isDisabled).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default TestPaperService
